export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  author: string;
  publishDate: string;
  image: string;
  tags: string[];
  views: number;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '《流浪地球3》票房突破50亿，国产科幻电影再创新高',
    summary: '《流浪地球3》上映仅两周便突破50亿票房大关，成为中国影史票房最高的科幻电影，标志着国产科幻电影工业化体系日趋成熟。',
    content: `<p>由郭帆执导、刘德华、吴京等主演的科幻巨制《流浪地球3》自上映以来，票房一路高歌猛进。截至本周，该片累计票房已突破50亿元人民币，成为中国影史票房最高的科幻电影。</p>
<p>该片延续了前两部的高水准制作，在视觉效果、剧情深度和人物塑造上都达到了新的高度。影片讲述太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园的故事。</p>
<p>影片在海外市场同样表现亮眼，北美、欧洲、东南亚等地区的票房均创下国产电影在当地的新纪录。业内分析人士认为，《流浪地球3》的成功不仅在于其精良的制作，更在于它触及了人类共同面对的命运议题，具有跨越文化的情感共鸣。</p>
<p>导演郭帆在接受采访时表示："我们希望通过这部电影，让世界看到中国科幻电影的实力。科幻是连接全人类的桥梁，我们有信心讲述属于全人类的故事。"</p>
<p>随着《流浪地球3》的成功，国产科幻电影迎来了新的发展机遇。多位业内人士表示，中国科幻电影工业化体系正在日益成熟，未来将有更多优秀的国产科幻作品与观众见面。</p>`,
    category: 'movie',
    author: '影视观察员',
    publishDate: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20scene%20with%20spaceship%20and%20earth%2C%20cinematic%20wide%20shot%2C%20dramatic%20space%20lighting%2C%20epic%20scale%2C%20warm%20orange%20glow%2C%20film%20still%20quality&width=800&height=450&seq=article-cover-01&orientation=landscape',
    tags: ['流浪地球', '票房', '科幻电影', '国产电影'],
    views: 128500,
  },
  {
    id: 'article-2',
    title: '《哪吒之魔童闹海》动画技术揭秘：国产动画的工业化突破',
    summary: '从角色设计到特效渲染，《哪吒之魔童闹海》制作团队揭秘了背后惊人的技术细节，展示了国产动画电影的最新技术成就。',
    content: `<p>《哪吒之魔童闹海》自上映以来，凭借其惊艳的视觉效果和感人至深的故事获得了观众的一致好评。近日，该片的技术团队首次向外界详细揭秘了影片背后的制作技术。</p>
<p>据技术总监介绍，影片中哪吒的"三头六臂"变身镜头，单帧渲染时间最长达120小时。为了实现火焰与水墨的完美融合，技术团队专门开发了一套全新的粒子系统，能够同时模拟传统水墨画的笔触效果与现代动画的流体动力学。</p>
<p>"我们想要创造一种既具有中国传统美学韵味，又符合现代观众视觉审美的画面风格，"美术指导表示，"每一帧画面都是经过反复推敲和打磨的结果。"</p>
<p>影片中的水下场景也是一大技术难点。为了呈现逼真的水下光线折射和流体动态，团队开发了专门的水下光照模型，使得角色在水下的动作和表情都栩栩如生。</p>
<p>业内人士评价，《哪吒之魔童闹海》的技术水准已经达到了国际一流动画电影的水平，标志着国产动画电影工业化进程进入了新的阶段。</p>`,
    category: 'anime',
    author: '动画前沿',
    publishDate: '2026-07-25',
    image: 'https://readdy.ai/api/search-image?query=Chinese%203D%20animation%20character%20design%20process%2C%20mythological%20style%2C%20vibrant%20colors%2C%20artistic%20rendering%2C%20studio%20lighting%2C%20creative%20workspace&width=800&height=450&seq=article-cover-02&orientation=landscape',
    tags: ['哪吒', '动画技术', '国产动画', '特效'],
    views: 96200,
  },
  {
    id: 'article-3',
    title: '2026暑期档电影大盘点：这些电影值得一看',
    summary: '2026年暑期档多部重磅影片轮番上映，从国产科幻到动画巨制，本文为您盘点暑期档不容错过的精彩电影。',
    content: `<p>随着暑期到来，2026年电影暑期档正式拉开帷幕。今年暑期档堪称"神仙打架"，多部国产大片与引进片轮番上映，为观众奉上了一场精彩的视听盛宴。</p>
<p><strong>国产科幻力作：《流浪地球3》</strong></p>
<p>作为国产科幻电影的标杆之作，《流浪地球3》以精良的视觉特效和深邃的叙事赢得了观众的心。影片上映以来口碑票房双丰收，是暑期档当之无愧的头号种子。</p>
<p><strong>动画巨制：《哪吒之魔童闹海》</strong></p>
<p>延续了前作的精良制作，这部动画电影在视觉效果上更进一步。将中国传统神话与现代动画技术完美结合，适合全年龄段观众观看。</p>
<p><strong>温情喜剧：《热辣滚烫2》</strong></p>
<p>延续第一部的温情路线，这部影片以轻松幽默的方式讲述了一个关于成长与自我实现的故事，非常适合暑期全家观影。</p>
<p><strong>动作大片：《封神第二部》</strong></p>
<p>史诗级的战争场面和精良的特效制作，让这部神话动作大片成为暑期档的重磅选手。宏大的世界观和精彩的打斗场面值得在大银幕上体验。</p>
<p>无论您是科幻迷、动画爱好者还是喜剧片粉丝，这个暑期档都能找到适合您的电影。趁着假期，不妨走进电影院，享受一场光影之旅。</p>`,
    category: 'movie',
    author: '电影周刊',
    publishDate: '2026-07-20',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20movie%20theater%20interior%20with%20screening%20schedule%20board%2C%20summer%20atmosphere%2C%20bright%20lighting%2C%20posters%20on%20wall%2C%20cinematic%20style%2C%20wide%20shot&width=800&height=450&seq=article-cover-03&orientation=landscape',
    tags: ['暑期档', '电影推荐', '大片', '观影指南'],
    views: 156800,
  },
  {
    id: 'article-4',
    title: '《庆余年第二季》结局解析：那些你可能错过的细节',
    summary: '《庆余年第二季》收官，剧中埋藏的大量伏笔和细节令人回味无穷。本文深度解析大结局中那些容易被忽略的关键信息。',
    content: `<p>《庆余年第二季》以一场惊心动魄的权力博弈完美收官，但剧中隐藏的大量伏笔和细节，你发现了吗？</p>
<p><strong>陈萍萍的真实目的</strong></p>
<p>在结局中，陈萍萍的一系列行动看似矛盾，实则暗藏深意。通过回看前面几集的细节可以发现，他从始至终都在为范闲铺路，只是手段之隐晦令人叹为观止。</p>
<p><strong>神庙的秘密</strong></p>
<p>第二季中多次出现的"神庙"意象并非偶然。结合第一季的剧情线索，神庙很可能与范闲的身世之谜有着千丝万缕的联系。导演在采访中也暗示，第三季将围绕神庙展开更加宏大的叙事。</p>
<p><strong>范闲的成长弧光</strong></p>
<p>从第一季的懵懂少年到第二季的成熟谋士，范闲的角色成长令人印象深刻。结局中他做出的选择，标志着这个角色真正完成了从一个"穿越者"到"庆国人"的身份转变。</p>
<p><strong>留给第三季的悬念</strong></p>
<p>结局中多个未解之谜——北齐暗线的走向、叶轻眉的真正来历、以及庆帝背后隐藏的秘密——都为第三季埋下了充足的叙事空间。按照原著小说的篇幅，第三季的内容将更加波澜壮阔。</p>`,
    category: 'tv',
    author: '观剧达人',
    publishDate: '2026-07-18',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20with%20ancient%20palace%20interior%2C%20warm%20candle%20lighting%2C%20mysterious%20atmosphere%2C%20royal%20setting%2C%20cinematic%20shot%2C%20drama%20still&width=800&height=450&seq=article-cover-04&orientation=landscape',
    tags: ['庆余年', '剧情解析', '结局', '国产剧'],
    views: 213400,
  },
  {
    id: 'article-5',
    title: '国产动漫崛起之路：从《大闹天宫》到《哪吒》的技术进化史',
    summary: '回顾中国动画电影数十年的发展历程，从传统手绘到3D渲染，国产动漫经历了怎样的技术革新与艺术探索？',
    content: `<p>从1964年的《大闹天宫》到2025年的《哪吒之魔童闹海》，中国动画走过了六十余年的风雨历程。这条进化之路，既是中国动画技术的革新史，也是中国动画人不断探索艺术表达的奋斗史。</p>
<p><strong>手绘时代（1960s-1990s）</strong></p>
<p>以上海美术电影制片厂为代表的老一辈动画人，用手绘的方式创造了一大批经典作品。《大闹天宫》《哪吒闹海》《天书奇谭》等作品，凭借独特的中国美学风格在国际上获得了极高的赞誉。这一时期的动画虽然技术手段有限，但艺术价值极高，至今仍被视为中国动画的黄金时代。</p>
<p><strong>转型探索期（2000s-2010s）</strong></p>
<p>进入新世纪，面对好莱坞和日本动漫的双重冲击，国产动画开始了艰难的转型之路。这一时期虽然作品质量参差不齐，但为后来的崛起积累了宝贵的技术经验和人才培养基础。</p>
<p><strong>全面崛起期（2015年至今）</strong></p>
<p>《西游记之大圣归来》的成功标志着国产动画进入了全面崛起的新阶段。此后，《哪吒之魔童降世》《白蛇：缘起》《长安三万里》等一系列优秀作品接连涌现，不仅在票房上屡创佳绩，在技术和艺术层面也达到了国际一流水平。</p>
<p>如今，中国的动画产业已经形成了完整的工业化体系，从前期设计到后期特效，每一个环节都有专业团队支撑。我们有理由相信，国产动漫的未来会更加精彩。</p>`,
    category: 'anime',
    author: '动漫志',
    publishDate: '2026-07-15',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20history%20collage%2C%20traditional%20hand%20drawn%20to%20modern%203D%20evolution%2C%20artistic%20comparison%2C%20warm%20museum%20lighting%2C%20educational%20display%20style&width=800&height=450&seq=article-cover-05&orientation=landscape',
    tags: ['国产动漫', '动画历史', '技术进化', '哪吒'],
    views: 78400,
  },
  {
    id: 'article-6',
    title: '《繁花》导演专访：用镜头还原九十年代的上海记忆',
    summary: '独家对话《繁花》导演，听他讲述如何通过镜头语言和美术设计，将九十年代上海的独特韵味呈现在荧幕之上。',
    content: `<p>电视剧《繁花》以其独特的视觉风格和浓郁的年代感征服了无数观众。近日，我们有幸采访到了该剧导演，听他讲述创作背后的故事。</p>
<p><strong>还原年代的挑战</strong></p>
<p>"九十年代的上海是一个充满魔力的城市，"导演回忆道，"那时候的黄河路、进贤路，和现在完全不一样。我们花了大量时间翻阅老照片、纪录片，甚至找到了当年在这些地方生活过的老人来讲述故事。"</p>
<p><strong>光影中的上海</strong></p>
<p>《繁花》最为人称道的就是其独特的光影美学。导演透露，影片大量使用了金黄色调和朦胧光效，这是对那个年代上海特有氛围的艺术再现。"九十年代的上海有一种独特的'金光'，那是改革开放初期特有的希望之光。"</p>
<p><strong>演员与角色</strong></p>
<p>谈及演员的选择，导演表示每一位演员都是精心挑选的结果。"阿宝这个角色需要一个既有市井气息又有大格局的演员。我们找了很多人才最终确定。现在看来，这个选择是对的。"</p>
<p><strong>未来的计划</strong></p>
<p>对于观众期待的续集或电影版，导演表示："繁花的故事还有很多可以讲，但需要找到合适的时机和方式。好的作品需要沉淀，我们不着急。"</p>`,
    category: 'tv',
    author: '娱乐深度',
    publishDate: '2026-07-10',
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20at%20night%2C%20neon%20lights%2C%20nostalgic%20atmosphere%2C%20retro%20Chinese%20city%2C%20warm%20golden%20tones%2C%20cinematic%20wide%20shot&width=800&height=450&seq=article-cover-06&orientation=landscape',
    tags: ['繁花', '导演专访', '上海', '年代剧'],
    views: 89200,
  },
];